var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"checkbox--wrapper"},[_c('button',{staticClass:"checkbox--button",class:{
        'checkbox--button__true': item.bool,
        'checkbox--button__disabled': _vm.counter >= _vm.limit && item.bool === false,
      },attrs:{"disabled":_vm.counter >= _vm.limit && item.bool === false},on:{"click":function($event){return _vm.click(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }